// cspell:disable

export enum SupportedCarrier {
  AAA_COOPER_TRANSPORTATION = "aaa_cooper_transportation",
  ACI_LOGISTIX = "aci_logistix",
  AIRTERRA = "airterra",
  AMAZON = "amazon", // Amazon Shipping + Amazon MCF
  // AMAZON_FR = "amazon_fr", // Malomo carrier not supported without new TrackingProviders
  AMAZON_IN = "amazon_in",
  AMAZON_IT = "amazon_it",
  AMAZON_UK = "amazon_uk",
  APC_POSTAL_LOGISTICS = "apc_postal_logistics",
  APG_ECOMMERCE = "apg_ecommerce",
  ARAMEX = "aramex",
  ARAMEX_AU = "aramex_au",
  ARAMEX_NZ = "aramex_nz",
  ARC_BEST = "arc_best",
  ASENDIA_USA = "asendia_usa",
  AUSTRALIA_POST = "australia_post",
  AXLEHIRE = "axlehire",
  BEN_BEN = "ben_ben",
  BETTER_TRUCKS = "better_trucks",
  BPOST = "bpost",
  BRING = "bring",
  CAINIAO = "cainiao",
  CANADA_POST = "canada_post",
  CANPAR = "canpar",
  CDL = "cdl",
  CEVA_LOGISTICS = "ceva_logistics",
  CHIT_CHATS = "chit_chats",
  CHINA_POST = "china_post",
  CHRONOPOST = "chronopost",
  CIRRO_ECOMMERCE = "cirro_ecommerce",
  CIRRO_PARCEL = "cirro_parcel",
  CITY_MAIL_PK = "city_mail_pk",
  CITY_MAIL_SE = "city_mail_se",
  // CLOUDSORT = "cloudsort", // Malomo carrier not supported without new TrackingProviders
  COLIS_PRIVE = "colis_prive",
  COURIER_EXPRESS = "courier_express",
  COURIERSPLEASE = "couriersplease",
  CTT_EXPRESS = "ctt_express",
  DAI_POST = "dai_post",
  // DELIVERIT = "deliverit", // Malomo carrier not supported without new TrackingProviders
  DEUTSCHE_POST = "deutsche_post",
  DEUTSCHE_POST_UK = "deutsche_post_uk",
  DHL_ECOMMERCE_ASIA = "dhl_ecommerce_asia",
  // DHL_ECOMMERCE_CA = "dhl_ecommerce_ca", // Malomo carrier not supported without new TrackingProviders
  DHL_ECOMMERCE = "dhl_ecommerce",
  DHL_EXPRESS = "dhl_express",
  DHL_PAKET = "dhl_paket",
  DHL_PARCEL = "dhl_parcel",
  DHL_PARCEL_NL = "dhl_parcel_nl",
  DOORDASH = "doordash",
  DPD = "dpd",
  DPD_LOCAL = "dpd_local",
  DPD_NL = "dpd_nl",
  DPD_UK = "dpd_uk",
  EPOST_GLOBAL = "epost_global",
  ESHIPPER = "eshipper",
  ESTAFETA = "estafeta",
  ESTES = "estes",
  EVRI = "evri",
  // FASTWAY = "fastway", // Malomo carrier not supported without new TrackingProviders
  FEDEX_CROSS_BORDER = "fedex_cross_border",
  FEDEX = "fedex",
  FEDEX_MAILVIEW = "fedex_mailview",
  FEDEX_SAMEDAY_CITY = "fedex_sameday_city",
  FEDEX_SMART_POST = "fedex_smart_post",
  FIRSTMILE = "firstmile",
  FLEET_OPTICS = "fleet_optics",
  FOUR_PX = "four_px",
  // GLS_EU = "gls_eu", // Malomo carrier not supported without new TrackingProviders
  GLS = "gls",
  GOBOLT = "gobolt",
  GOFO_EXPRESS = "gofo_express",
  HAILIFY = "hailify",
  HERMES_DE = "hermes_de",
  ICS = "ics",
  IMILE = "imile",
  INTELCOM = "intelcom",
  INTERLINK_EXPRESS = "interlink_express",
  JAPAN_POST = "japan_post", // JP Post
  JITSU = "jitsu",
  JS_EXPRESS = "js_express",
  KART2DOOR = "kart2door",
  LANDMARK_GLOBAL = "landmark_global",
  // LA_POSTE_FR = "la_poste_fr", // Malomo carrier not supported without new TrackingProviders
  LASERSHIP = "lasership",
  LOOMIS_EXPRESS = "loomis_express",
  LOTTE_GLOBAL_LOGISTICS = "lotte_global_logistics",
  LSO = "lso",
  // MAERGO = "maergo", // Malomo carrier not supported without new TrackingProviders
  MAINFREIGHT = "mainfreight",
  METROPOLITAN = "metropolitan",
  NEWGISTICS = "newgistics",
  NEXTSMARTSHIP = "nextsmartship",
  NINJAVAN = "ninjavan",
  NORWAY_POST = "norway_post",
  NZ_POST = "nz_post", // New Zealand Post
  // OLD_DOMINION_FREIGHT_LINE = "old_dominion_freight_line", // Malomo carrier not supported without new TrackingProviders
  OMNI_PARCEL = "omni_parcel",
  OMNIVA = "omniva",
  ON_TRAC = "on_trac",
  OPTIMA = "optima",
  OSM_WORLDWIDE = "osm_worldwide",
  PARCELFORCE = "parcelforce",
  PARCLL = "parcll",
  PASSPORT = "passport",
  PITNEY_BOWES = "pitney_bowes",
  POLAND_POST = "poland_post",
  POSTNL = "postnl",
  PUROLATOR = "purolator",
  RELAY = "relay",
  ROYAL_MAIL = "royal_mail",
  ROYAL_MAIL_V3 = "royal_mail_v3",
  R_PLUS_L_CARRIERS = "r_plus_l_carriers",
  SAGAWA = "sagawa",
  SAIA = "saia",
  SEKO = "seko",
  SENDLE = "sendle",
  SF_EXPRESS = "sf_express",
  SHIP_BOB = "ship_bob",
  SINGAPORE_POST = "singapore_post",
  SMARTKARGO = "smartkargo",
  SONIC = "sonic",
  SOUTHEASTERN_FREIGHT_LINES = "southeastern_freight_lines",
  SPEEDEE = "speedee",
  SPEEDX = "speedx",
  STARTRACK = "startrack",
  STONE3PL = "stone3pl",
  SWAY = "sway",
  SUNYOU = "sunyou",
  SWISS_POST = "swiss_post",
  SWYFT = "swyft",
  TELE_POST = "tele_post",
  TFORCE = "tforce",
  TOLL = "toll",
  TUSK = "tusk",
  UDS = "uds",
  UNIUNI = "uniuni",
  // UPS_IPARCEL = "ups_iparcel", // Malomo carrier not supported without new TrackingProviders
  UPS_MAIL_INNOVATIONS = "ups_mail_innovations",
  UPS = "ups",
  USPS = "usps",
  VEHO = "veho",
  WANB_EXPRESS = "wanb_express",
  WIZMO = "wizmo",
  WHISTL = "whistl",
  XPO = "xpo",
  // YAMATO = "yamato", // Malomo carrier not supported without new TrackingProviders
  YANWEN = "yanwen",
  YODEL = "yodel",
  YUN_EXPRESS = "yun_express",
}
